export default __webpack_public_path__ + "static/img_2-ee28d9291d47d462d64f066a167bd392.jpg";